var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5vw",
    height: "5vw",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 52H40.5C40.2348 52 39.9804 51.8946 39.7929 51.7071C39.6054 51.5196 39.5 51.2652 39.5 51V49C39.5 48.7348 39.6054 48.4804 39.7929 48.2929C39.9804 48.1054 40.2348 48 40.5 48H49.5C49.7652 48 50.0196 48.1054 50.2071 48.2929C50.3946 48.4804 50.5 48.7348 50.5 49V51C50.5 51.2652 50.3946 51.5196 50.2071 51.7071C50.0196 51.8946 49.7652 52 49.5 52Z",
    fill: "#B1C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 28H31.5C31.2348 28 30.9804 28.1054 30.7929 28.2929C30.6054 28.4804 30.5 28.7348 30.5 29V31C30.5 31.2652 30.6054 31.5196 30.7929 31.7071C30.9804 31.8946 31.2348 32 31.5 32H49.5C49.7652 32 50.0196 31.8946 50.2071 31.7071C50.3946 31.5196 50.5 31.2652 50.5 31V29C50.5 28.7348 50.3946 28.4804 50.2071 28.2929C50.0196 28.1054 49.7652 28 49.5 28Z",
    fill: "#2EC5CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 34H31.5C31.2348 34 30.9804 34.1054 30.7929 34.2929C30.6054 34.4804 30.5 34.7348 30.5 35V45C30.5 45.2652 30.6054 45.5196 30.7929 45.7071C30.9804 45.8946 31.2348 46 31.5 46H49.5C49.7652 46 50.0196 45.8946 50.2071 45.7071C50.3946 45.5196 50.5 45.2652 50.5 45V35C50.5 34.7348 50.3946 34.4804 50.2071 34.2929C50.0196 34.1054 49.7652 34 49.5 34Z",
    fill: "#3050F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.e074cc41.svg";
export { ForwardRef as ReactComponent };